'use client';

import { useContext } from 'react';

import { BioUserAccessContext } from './context';

/**
 * Read the signed-in viewer's access relationship (follow / subscription level)
 * with the bio's creator. Always returns a value — outside a provider, or before
 * the relationship resolves, callers get the stranger sentinel, so there's no
 * `undefined` to defend against.
 */
export function useBioUserAccess() {
  return useContext(BioUserAccessContext);
}
